import { useEffect } from "react";

export const useInsytWidget = (authData) => {
  useEffect(() => {
    const initializeWidget = () => {
      if (window.InsytWidget) {
        window.InsytWidget.authorize(authData);
      } else {
        // If widget hasn't loaded yet, wait and try again
        setTimeout(initializeWidget, 1000);
      }
    };

    initializeWidget();
  }, [authData]);
};
